// src/components/ui/ComoTrabajamos.jsx
import React from "react";
import { FadeIn, SlideIn } from "./animations";
import { useNavigate } from "react-router-dom";
import { useServiciosDestacados } from "../../hooks/useServiciosDestacados";

const ComoTrabajamos = () => {
  const navigate = useNavigate();

  const {
    items: servicios = [],
    loading: serviciosLoading = true,
    error: serviciosError = "",
  } = useServiciosDestacados();


  return (
    <section
      id="como-funciona"
      className="relative z-10 max-w-6xl mx-auto px-6 sm:px-10 md:px-16 pt-16 pb-24
                scroll-mt-28 md:scroll-mt-36"
    >
      {/* BLOQUE: CÓMO FUNCIONA EKINE */}
      <div className="text-center mb-10">
        <FadeIn>
          <h2 className="text-2xl md:text-3xl font-bold text-[#00698F]">
            ¿Cómo funciona EKINE?
          </h2>
        </FadeIn>

        <FadeIn y={4}>
          <p className="mt-2 text-sm md:text-base text-[#00698F]/75">
            Un proceso simple para que puedas comenzar tu rehabilitación y
            entrenamiento cuanto antes.
          </p>
        </FadeIn>
      </div>

      <div className="grid gap-4 md:gap-6 md:grid-cols-3 items-stretch">
        {/* 1) AGENDA EN MINUTOS → navega */}
          <SlideIn dir="up">
            <button
              onClick={() => navigate("/agenda")}
              className="w-full h-full flex flex-col text-left rounded-2xl bg-white
                        shadow-[0_18px_40px_-22px_rgba(15,23,42,0.35)]
                        px-5 py-6 border border-slate-100
                        hover:shadow-[0_22px_50px_-20px_rgba(15,23,42,0.45)]
                        hover:-translate-y-0.5 transition-all duration-200 focus:outline-none"
            >
              <p className="text-base font-semibold text-[#06b6fa] mb-2">
                1) Agenda en minutos
              </p>
              <p className="text-sm md:text-base text-[#0b2052] leading-relaxed">
                Elige servicio, fecha y hora desde tu celular o computador.
              </p>
            </button>
          </SlideIn>

        {/* 2) RECIBE CONFIRMACIÓN → informativo */}
        <SlideIn dir="up" delay={0.06}>
          <div
            className="rounded-2xl bg-white px-5 py-6 border border-slate-100 cursor-default
                      shadow-[0_18px_40px_-22px_rgba(15,23,42,0.35)]
                      hover:shadow-[0_22px_50px_-20px_rgba(15,23,42,0.45)]
                      hover:-translate-y-0.5 transition-all duration-200"
          >
            <p className="text-sm font-semibold text-[#06b6fa] mb-1">
              2) Recibe confirmación
            </p>
            <p className="text-sm md:text-base text-[#0b2052] leading-relaxed">
              Recordatorios automáticos y tu historial clínico a mano.
            </p>
          </div>
        </SlideIn>

        {/* 3) OPTIMIZA TU RECUPERACIÓN → informativo */}
        <SlideIn dir="up" delay={0.12}>
          <div
            className="rounded-2xl bg-white px-5 py-6 border border-slate-100 cursor-default
                      shadow-[0_18px_40px_-22px_rgba(15,23,42,0.35)]
                      hover:shadow-[0_22px_50px_-20px_rgba(15,23,42,0.45)]
                      hover:-translate-y-0.5 transition-all duration-200"
          >
            <p className="text-sm font-semibold text-[#06b6fa] mb-1">
              3) Optimiza tu recuperación
            </p>
            <p className="text-sm md:text-base text-[#0b2052] leading-relaxed">
              Planes personalizados y seguimiento basado en evidencia.
            </p>
          </div>
        </SlideIn>
      </div>


      {/* SEPARADOR */}
      <div className="mt-12 border-t border-slate-200" />

      {/* BLOQUE: SERVICIOS MÁS SOLICITADOS */}
      <div className="mt-10">
        <FadeIn>
          <h3 className="text-2xl md:text-2xl font-bold text-[#00698F] text-center mb-6">
            Servicios más solicitados
          </h3>
        </FadeIn>

        <div className="grid gap-6 md:grid-cols-2">
          {serviciosLoading && (
            <>
              <div className="h-44 rounded-2xl bg-white border border-slate-100 shadow-[0_18px_40px_-22px_rgba(15,23,42,0.35)]" />
              <div className="h-44 rounded-2xl bg-white border border-slate-100 shadow-[0_18px_40px_-22px_rgba(15,23,42,0.35)]" />
            </>
          )}

          {!serviciosLoading && serviciosError && (
            <div className="md:col-span-2 text-center text-sm text-red-600">
              No se pudieron cargar los servicios destacados.
            </div>
          )}

          {!serviciosLoading && !serviciosError && servicios.length === 0 && (
            <div className="md:col-span-2 text-center text-sm text-[#0A1440]/70">
              Aún no hay servicios destacados activos.
            </div>
          )}

          {servicios.map((s, idx) => (
            <SlideIn key={s.id} dir="up" delay={idx * 0.08}>
              <article className="flex flex-col md:flex-row bg-white rounded-2xl shadow-[0_18px_40px_-22px_rgba(15,23,42,0.35)] overflow-hidden border border-slate-100">
                <div className="md:w-1/2 aspect-[4/3]">
                  <img
                    src={s.imagenURL || "/fotos/placeholder.jpg"}
                    alt={s.titulo || "Servicio destacado"}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>

                <div className="md:w-1/2 p-5 md:p-6 flex flex-col justify-between">
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1440] mb-1">
                      {s.titulo}
                    </h4>

                    {s.descripcion && (
                      <p className="text-sm text-[#0A1440]/75 mb-3">
                        {s.descripcion}
                      </p>
                    )}

                    {Array.isArray(s.bullets) && s.bullets.length > 0 && (
                      <ul className="text-xs text-[#0A1440]/70 space-y-1">
                        {s.bullets.map((b, i) => (
                          <li key={i}>• {b}</li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <button
                    onClick={() => navigate(s.ctaLink || "/agenda")}
                    className="mt-4 inline-flex justify-center rounded-xl bg-[#0284C7] text-white text-sm font-semibold px-4 py-2 hover:bg-[#06b6fa] transition"
                  >
                    {s.ctaText || "Agendar sesión"}
                  </button>
                </div>
              </article>
            </SlideIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComoTrabajamos;
